import React from 'react';
import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import AdminLayout from './layouts/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import TenantDetail from './pages/TenantDetail';
import Services from './pages/Services';
import Billing from './pages/Billing';
import Settings from './pages/Settings';
import AIQuality from './pages/AIQuality';
import Templates from './pages/Templates';
import Features from './pages/Features';
import PlatformEmailSettings from './pages/PlatformEmailSettings';
import TwilioNumberPool from './pages/TwilioNumberPool';
import TemplateStudio from './pages/TemplateStudio';
import StudioFieldManager from './pages/studio/FieldManager';
import StudioWorkflowBuilder from './pages/studio/WorkflowBuilder';
import StudioScreenManager from './pages/studio/ScreenManager';
import StudioScreenBuilder from './pages/studio/ScreenBuilder';
import StudioTitleBuilder from './pages/studio/TitleBuilder';
import StudioRelationshipManager from './pages/studio/RelationshipManager';

function ProtectedRoute({ children }) {
  const { token, user } = useAuthStore();
  if (!token || !user) return <Navigate to="/login" replace />;
  return children;
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="tenants/:id" element={<TenantDetail />} />
        <Route path="services" element={<Services />} />
        <Route path="billing" element={<Billing />} />
        <Route path="features" element={<Features />} />
        <Route path="templates" element={<Templates />} />
        <Route path="template-studio" element={<TemplateStudio />} />
        <Route path="template-studio/:recordTypeId/fields" element={<StudioFieldManager />} />
        <Route path="template-studio/:recordTypeId/workflow" element={<StudioWorkflowBuilder />} />
        <Route path="template-studio/:recordTypeId/screens" element={<StudioScreenManager />} />
        <Route path="template-studio/:recordTypeId/screens/:screenId/builder" element={<StudioScreenBuilder />} />
        <Route path="template-studio/:recordTypeId/title" element={<StudioTitleBuilder />} />
        <Route path="template-studio/:recordTypeId/relationships" element={<StudioRelationshipManager />} />
        <Route path="ai-quality" element={<AIQuality />} />
        <Route path="settings" element={<Settings />} />
        <Route path="platform-email" element={<PlatformEmailSettings />} />
        <Route path="twilio-numbers" element={<TwilioNumberPool />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </>
  ),
  { future: { v7_relativeSplatPath: true } }
);

function App() {
  return (
    <>
      <Toaster position="top-right" />
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </>
  );
}

export default App;
